export const colors = {
  black: "#111111",
  white: "#ffffff",
  primary: "#111111",
  primary_highlight: "#111111",
  secondary: "#E6F7FF",
  darkgray: "#7F8F91",
  gray: "#CED4E0",
  lightgray: "#FBFCFE",
  lightgray_highlight: "#F5F6F9",
}

export const titleTextStyle = `
  font-size: 24px;
  font-weight: 600;
  color: ${colors.black};
  white-space: pre-wrap;
`;

export const subtitleTextStyle = `
  font-size: 18px;
  font-weight: 550;
  color: ${colors.black};
  white-space: pre-wrap;
`;

export const bodyTextStyle = `
  font-size: 16px;
  line-height: 1.6;
  color: ${colors.black};
  white-space: pre-wrap;
`;

export const tagTextStyle = `
  font-size: 14px;
  color: ${colors.darkgray};
  white-space: pre-wrap;
`;